import React from 'react'
import Button from './Button'
import { Link as ScrollLink } from "react-scroll";
export default function Footer() {
    return (
        <>

            <div className='bg-[#161C2D] py-10 px-5'>

                <div className='sm:max-w-[80%] mx-auto text-gray-50'>
                    <div className="text-center sm:text-start sm:flex sm:justify-between items-center ">
                        <div className='text-center sm:text-start'>
                            <h2 className='text-xl sm:text-3xl font-semibold max-w-[500px]'>Ready to launch your next project?</h2>
                            <p className=' sm:font-semibold my-3 sm:mt-1 text-gray-400'>Get in touch or book a free consultation to know more.</p>
                        </div>
                        <div className="shrink-0  ">
                            <Button text="Start a project" />
                        </div>
                    </div>


                    <div className='mt-20 flex flex-wrap gap-6 sm:gap-0 sm:justify-between lg:gap-[24px]'>
                        <div className='w-full sm:w-[calc(50%-16px)] lg:w-[calc(25%-18px)] mb-5 text-start sm:text-center lg:text-start'>
                            <h6 className='text-lg sm:text-2xl font-semibold '>Simplify</h6>
                            <div className='my-5'>
                                <p className='text-gray-300 text-sm'>
                                    With lots of unique blocks, you can easily build a page without coding. Build your next landing page.
                                </p>

                            </div>
                        </div>
                        <div className='w-full sm:w-[calc(50%-16px)] lg:w-[calc(25%-18px)] sm:text-center mb-5'>
                            <h6 className='text-lg text-gray-400 font-semibold '>Company</h6>

                            <div className='flex flex-col gap-2 mt-4'>
                                <ScrollLink
                                    to="top"
                                    spy={true}
                                    smooth={true}
                                    offset={-70}
                                    duration={500} className='cursor-pointer text-sm sm:text-[16px]' >About Us</ScrollLink>
                                <ScrollLink to="our_services"
                                
                                    spy={true}
                                    smooth={true}
                                    offset={-70}
                                    duration={500}  className='cursor-pointer text-sm sm:text-[16px]' >Our Services</ScrollLink>
                                <ScrollLink to="why-us"
                                
                                    spy={true}
                                    smooth={true}
                                    offset={-70}
                                    duration={500}  className='cursor-pointer text-sm sm:text-[16px]' >Why-Us</ScrollLink>
                                <ScrollLink to="work_sample"
                                
                                    spy={true}
                                    smooth={true}
                                    offset={-70}
                                    duration={500}  className='cursor-pointer text-sm sm:text-[16px]' >Work Sample</ScrollLink>

                            </div>
                        </div>

                        <div className='w-full sm:w-[calc(50%-16px)] lg:w-[calc(25%-18px)] sm:text-center mb-5'>
                            <h6 className='text-lg text-gray-400 font-semibold '>Products</h6>

                            <div className='flex flex-col gap-2 mt-4'>
                                <a href="#a" target='_blank' className='text-sm sm:text-[16px]' >Business CRM</a>
                                <a href="#a" target='_blank' className='text-sm sm:text-[16px]' >IT Website Template</a>
                                <a href="#a" target='_blank' className='text-sm sm:text-[16px]' >Complaint Management System</a>

                            </div>
                        </div>

                        <div className='w-full sm:w-[calc(50%-16px)] lg:w-[calc(25%-18px)] sm:text-center mb-5'>
                            <h6 className='text-lg text-gray-400 font-semibold '>Services</h6>

                            <div className='flex flex-col gap-2 mt-4'>
                                <a href="#about" className='text-sm sm:text-[16px]' >Web Development</a>
                                <a href="#about" className='text-sm sm:text-[16px]' >Designing</a>
                                <a href="#about" className='text-sm sm:text-[16px]' >Android Development</a>
                                <a href="#about" className='text-sm sm:text-[16px]' >Digital Marketing</a>

                            </div>
                        </div>


                    </div>

                    <hr className='border-none bg-gray-500 h-[2px] my-5' />

                    <div className='flex flex-wrap justify-center sm:justify-between items-center gp-3'>
                        <div className="social_icons flex justify-center md:justify-start space-x-2 mb-2">
                            <a href='/' className="rounded-full py-2 px-3 bg-[#EFF0FF] text-violet-600 text-lg sm:text-xl hover:bg-violet-600 hover:text-white hover:shadow-2xl hover:shadow-gray-200 duration-200">
                                <i className="bi bi-instagram"></i>
                            </a>
                            <a href='/' className="rounded-full py-2 px-3 bg-[#EFF0FF] text-violet-600 text-lg sm:text-xl hover:bg-violet-600 hover:text-white hover:shadow-2xl hover:shadow-gray-200 duration-200">
                                <i className="bi bi-facebook"></i>
                            </a>
                            <a href='/' className="rounded-full py-2 px-3 bg-[#EFF0FF] text-violet-600 text-lg sm:text-xl hover:bg-violet-600 hover:text-white hover:shadow-2xl hover:shadow-gray-200 duration-200">
                                <i className="bi bi-twitter"></i>
                            </a>
                        </div>
                        <p className='text-start sm:text-center text-gray-300 text-sm my-1'>&copy; {new Date().getFullYear()} Simplify. All rights reserved.</p>
                    </div>


                </div>

            </div>

        </>
    )
}
